<div class="modal-body vtr-modal-hardware-scan-customize">

	<div class="row modal-information">
		<h1 class="title" id="hwscan-customize-modal-title" role="heading">{{ 'hardwareScan.customize.test' | translate }}</h1>
		<p class="description" id="hwscan-customize-modal-description" role="text">{{ 'hardwareScan.customize.description' | translate }}</p>
	</div>

	<vtr-ui-hardware-list-test
		[componentId]="'hwscan-customize-scan-list'"
		[items]="items"
		(selectAny)="receiveSelect()">
	</vtr-ui-hardware-list-test>

	<div class="row button-row">
		<vtr-material-button
			linkId="hwscan-run-selected-tests-btn"
			[isDisabled]="disableButtonRun"
			[label]="'hardwareScan.customize.runTests' | translate | uppercase"
			[tooltipText] ="'hardwareScan.customize.runTests' | translate"
			(buttonClick)="onClickRun()"
			heightSize="lg">
		</vtr-material-button>
	</div>

	<div class="btn-modal-close">
		<vtr-ui-close-button
			linkId="hwscan-customize-scan-modal-close-btn"
			(clickClose)="closeModal()">
		</vtr-ui-close-button>
	</div>

</div>
